/**
 * @generated SignedSource<<d70b7ae7778dd7c639e2638363b5d134>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OfferMessageStatusUpdate_offer$data = {
  readonly artist: {
    readonly displayName: string;
  };
  readonly partner: {
    readonly displayName: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"OfferNextStep_offer">;
  readonly " $fragmentType": "OfferMessageStatusUpdate_offer";
};
export type OfferMessageStatusUpdate_offer$key = {
  readonly " $data"?: OfferMessageStatusUpdate_offer$data;
  readonly " $fragmentSpreads": FragmentRefs<"OfferMessageStatusUpdate_offer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "displayName",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OfferMessageStatusUpdate_offer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArtistNode",
      "kind": "LinkedField",
      "name": "artist",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PartnerNode",
      "kind": "LinkedField",
      "name": "partner",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OfferNextStep_offer"
    }
  ],
  "type": "OfferNode",
  "abstractKey": null
};
})();

(node as any).hash = "a65f7a20748e0a0715fe01719dda2053";

export default node;
